"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enum = void 0;
require("reflect-metadata");
var DecoratorSymbol_1 = require("./DecoratorSymbol");
/**
 * Decorate a field as enum value
 *
 * @param enumObject
 * @constructor
 */
var Enum = function (enumObject) {
    return function (Target, property) {
        Object.defineProperty(Target, property, {
            enumerable: true,
            configurable: true,
            get: function () {
                return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
            },
            set: function (value) {
                Object.defineProperty(this, property, {
                    enumerable: true,
                    configurable: false,
                    get: function () {
                        return Reflect.getMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, this, property);
                    },
                    set: function (value) {
                        if (value === null || value === undefined) {
                            Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, value, this, property);
                            return;
                        }
                        var values = Object.values(enumObject);
                        if (!values.includes(value)) {
                            throw new Error("Value " + value + " is not a member of enum { " + values.join(', ') + " }");
                        }
                        Reflect.defineMetadata(DecoratorSymbol_1.DecoratorSymbol.RAW_VALUE, value, this, property);
                    }
                });
                this[property] = value;
            }
        });
    };
};
exports.Enum = Enum;
//# sourceMappingURL=Enum.js.map